import _classCallCheck from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { backend_util } from '@tensorflow/tfjs-core';
var CHECK_NAN_SNIPPET = "\n  if (isnan(a)) return a;\n  if (isnan(b)) return b;\n";
export var ADD = 'return a + b;';
export var SUB = 'return a - b;';
export var MUL = 'return a * b;'; // We use native integer division to deal with floating point imprecision. Since
// we implement floor division and glsl implements truncated division, we
// correct for this by subtracting 1 from result when the result is negative and
// there is a remainder.

export var INT_DIV = "\n  float s = sign(a) * sign(b);\n  int ia = round(a);\n  int ib = round(b);\n  if (ib != 0) {\n    // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n    return float(idiv(ia, ib, s));\n  } else {\n    return NAN;\n  }\n";
export var POW = "\nif(a < 0.0 && floor(b) < b){\n  return NAN;\n}\nif (b == 0.0) {\n  return 1.0;\n}\nreturn (round(mod(b, 2.0)) != 1) ?\n    pow(abs(a), b) : sign(a) * pow(abs(a), b);\n";
export var SQUARED_DIFFERENCE = 'return (a - b) * (a - b);';
export var EQUAL = "return float(a == b);";
export var NOT_EQUAL = "return float(a != b);";
export var LESS = "return float(a < b);";
export var LESS_EQUAL = "return float(a <= b);";
export var GREATER = "return float(a > b);";
export var GREATER_EQUAL = "return float(a >= b);";
export var LOGICAL_AND = "return float(a >= 1.0 && b >= 1.0);";
export var LOGICAL_OR = "return float(a >= 1.0 || b >= 1.0);";
export var MAX = CHECK_NAN_SNIPPET + "\n  return max(a, b);\n";
export var MIN = CHECK_NAN_SNIPPET + "\n  return min(a, b);\n";
export var MOD = "if (b == 0.0) return NAN;\n  return mod(a, b);";
export var ELU_DER = "return (b >= 1.0) ? a : a * (b + 1.0);";
export var PRELU = "return (a < 0.) ? b * a : a;";
export var BinaryOpProgram = function BinaryOpProgram(op, aShape, bShape) {
  _classCallCheck(this, BinaryOpProgram);

  this.variableNames = ['A', 'B'];
  this.outputShape = backend_util.assertAndGetBroadcastShape(aShape, bShape);
  this.userCode = "\n      float binaryOperation(float a, float b) {\n        ".concat(op, "\n      }\n\n      void main() {\n        float a = getAAtOutCoords();\n        float b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    ");
};